export default {
  buttons: {
    cancel: "Anuluj",
    confirm: "Potwierdź",
    save: "Zapisz",
    generate: "Generuj",
    generating: "Generowanie...",
  },
  access: {
    client_invoices: "Faktury klientów",
    doctors: "Lekarze",
    examinations_results: "Zlecenia - wyniki badań",
    "excluded-services": "Lista wykluczeń",
    features: "Features",
    guests: "Użytkownicy niezarejstrowani",
    impersonate: "Podszywanie się",
    invoices: "Faktury",
    "live-stats": "Sprzedaż live",
    logs: "Logi błędów",
    patients: "Pacjenci",
    promotions: "Promocje",
    referrals: "Zlecenia",
    reports: "Raporty",
    "withdrawal-contracts": "Lista odstąpień od umowy",
  },
  impersonation: {
    impersonate: "Podszywaj się",
    banner_text: "Tryb podszywania się",
    back_to_admin: "Powrót do panelu admina",
    started_by: "Rozpoczęte przez",
    error: "Nie udało się rozpocząć podszywania",
    logs_title: "Historia podszywania się",
    transitioning: "Podszywanie...",
    returning: "Powrót...",
    admin: "Admin",
    target: "Cel",
    role: "Rola",
    started_at: "Rozpoczęto",
    ended_at: "Zakończono",
    status_label: "Status",
    active: "Aktywna",
    ended: "Zakończona",
    no_logs: "Brak wpisów",
  },
  account: {
    blocked: "Twoje konto jest nieaktywne lub zablokowane",
    change_password: "Zmień swoje hasło",
    doctor: {
      blocked: "Twoje konto jest nieaktywne",
      contact_administrator:
        "Czas aktywacji konta po rejestracji wynosi do 48 godzin. W przypadku braku aktywacji lub możliwości zalogowania prosimy o kontakt pod adresem",
    },
    default_price_list: "Domyślny cennik badań laboratoryjnych",
    email: "Adres e-mail",
    keeper: "Opiekun",
    key_customer_sector:
      "Jeżeli już posiadasz swojego opiekuna z sektora centralnego – wybierz z listy",
    password: "Hasło",
    personal_data: "Dane osobowe",
    pwz: "pwz",
    setting: "Ustawienia konta",
    update_data: "Edytuj swoje dane",
    curator: "Opiekun",
  },
  action: {
    add: "Dodaj",
    add_to_referral: "Dodaj do zlecenia",
    cancel: "Anuluj",
    change: "Zmień",
    choose: "Wybierz",
    clear: "Wyczyść",
    collapse: "Zwiń",
    continue: "Kontynuuj",
    delete: "Usuń",
    download: "Pobierz",
    edit: "Edytuj",
    expand: "Rozwiń",
    filter: "Filtruj",
    go_back: "Wróć",
    return: "Powrót",
    save: "Zapisz",
    save_changes: "Zapisz zmiany",
    search: "Szukaj",
    see_details: "Zobacz szczegóły",
    see_doctor: "Zobacz lekarza",
    see_referral: "Zobacz zlecenie",
    show_all_exams: "Pokaż wszystkie badania, w tym niedostępne w e-sklepie",
    show_more: "Zobacz więcej",
    withdraw_funds: "Wypłać środki",
  },
  admin: {
    cities: {
      all: "Wszystkie",
    },
    curator: {
      create: "Dodaj Opiekuna",
      curator_data: "Dane Opiekuna",
      first_name: "Imię",
      last_name: "Nazwisko",
      email: "E-mail",
      registered_at: "Data rejestracji",
      phone_number: "Telefon",
      edit: "Zapisz dane",
      data_edit: "Edycja danych",
      full_name: "Imię i nazwisko",
      go_to_settings: "Przejdź do Ustawień",
      search_curator: "Wyszukaj opiekuna",
    },
    doctor: {
      account_inactice: "Konto jest nieaktywne",
      account_number: "Numer rachunku bankowego",
      address: "Adres",
      back_to_list: "Wróć do listy lekarzy",
      birth_date: "Data urodzenia",
      check_account_settings:
        "Sprawdz ustawienia swojego konta, dodaj dane do faktury jeżeli potrzebujesz.",
      city: "Miasto",
      commission: "Wynagrodzenie",
      company: "Firma",
      company_data: "Dane firmy",
      company_name: "Nazwa firmy / przychodni",
      contact_info:
        "Jeżeli aktywacja nie nastąpiła we wskazanym czasie skontaktuj się z nami pod adresem",
      create: "Dodaj lekarza",
      data_edit: "Edycja danych",
      data_show: "Podgląd danych",
      doctor_data: "Dane lekarza",
      edit: "Zapisz dane",
      email: "E-mail",
      curator_full_name: "Opiekun",
      first_name: "Imię",
      flat_number: "Numer lokalu",
      full_name: "Imię i nazwisko",
      go_to_settings: "Przejdź do Ustawień",
      house_number: "Numer budynku",
      last_name: "Nazwisko",
      main_medical_category: "Specjalizacja",
      nip: "NIP",
      pesel: "Pesel",
      phone_number: "Telefon",
      postal_code: "Kod pocztowy",
      pwz: "PWZ",
      referrrals_list: "Lista zleceń",
      registered_at: "Data rejestracji",
      search_doctor: "Znajdź lekarza",
      search_guest_user: "Znajdź niezarejestrowanego uzytkownika",
      search_patient: "Znajdź pacjenta",
      send_message: "Wyślij wiadomość",
      status: "Status",
      street: "Ulica",
      wait_for_activation:
        "Poczekaj do 48h na walidację konta ze strony naszych pracowników",
      we_call_to_you: "Zadzwonimy do Ciebie",
    },
    doctor_card: {
      barcode: "Kod kreskowy",
      city: "Miasto",
      commission: "Wynagrodzenie",
      date_of_examination: "Data wykonania badania",
      date_of_issue: "Data wystawienia",
      invoice: "Faktura",
      withdrawals: "Odstąpienia",
      withdrawal_date: "Data odstąpienia",
      withdrawal_reason: "Powód odstąpienia",
      import_date: "Data importu",
      is_home_service: "Alab w domu",
      order_id: "id w HL7",
      patient: "Pacjent",
      postal_code: "Kod pocztowy",
      referral_barcode: "Kod kreskowy",
      referral_number: "Numer zlecenia",
      source: "Źródło",
      status: "Status",
      street: "Ulica",
      test_date: "Data badań",
      total_price: "Cena",
    },
    excluded_services: {
      title: "Usługi wykluczone z promocji",
      search_placeholder: "Jakiej usługi szukasz?",
      examination_name: "Nazwa badania",
      bundle_name: "Nazwa pakietu",
      code: "Kod usługi",
      excluded_from_promotions: "Wykluczona z promocji",
      tab_examinations: "Badania",
      tab_bundles: "Pakiety",
    },
    invoices: {
      account_number: "Numer konta",
      add_file: "Dodaj plik",
      amount: "Kwota",
      amount_to_pay: "Kwota do zapłaty",
      csv: "csv",
      date_execution: "Data realizacji",
      date_of_issue: "Data wystawienia",
      date_of_order: "Data złożenia zamówienia",
      date_of_transfer: "Data przelewu",
      doctor: "Lekarz",
      download_all: "Pobierz wszystkie",
      download_invoice: "Pobierz",
      send_invoice: "Wyślij fakturę",
      resend_invoice: "Wyślij ponownie",
      mark_as_paid: "Oznacz jako opłacone",
      send_invoice_confirm_title: "Potwierdzenie wysłania faktury",
      send_invoice_confirm_text:
        "Czy na pewno chcesz {action} fakturę {invoice_number}?",
      mark_as_paid_confirm_title: "Potwierdzenie oznaczenia jako opłacone",
      mark_as_paid_confirm_text:
        "Czy na pewno chcesz oznaczyć fakturę {invoice_number} jako opłaconą?",
      generate_invoices: "Generuj faktury",
      generate_invoices_title: "Generuj faktury",
      generate_invoices_text:
        "Wybierz przeszły miesiąc, aby wygenerować faktury za ten okres.",
      select_date: "Wybierz miesiąc i rok",
      select_date_help: "Wybierz przeszły miesiąc do wygenerowania faktur.",
      invoice_issued: "Wystawiona",
      invoice_number: "Numer faktury",
      invoices: "Faktury",
      mark_as_issued: "Oznacz jako wystawioną",
      mark_as_issued_confirm:
        "Potwierdź, ze chcesz zmienic status faktury na wystawioną",
      new: "Nowe",
      order_number: "Numer zamówienia",
      paid: "Opłacone",
      purchaser_name: "Zamawiający",
      select_file: "Wybierz plik",
      select_month: "Wybierz miesiąc z którego chcesz pobrać faktury",
      status: "status",
      statuses: {
        all: "Wszystkie",
        new: "Nowa",
        paid: "Opłacona",
        to_send: "Wysłane",
        sent: "Wysłane",
      },
    },
    message: {
      choose_doctors: "Zaznacz do kogo chcesz wysłać wiadomość",
      message: "Treść wiadomości",
      recipients: "odbiorcy/ów",
      recipients_number: "Liczba odbiorców",
      send: "Wyślij wiadomość",
      sent: "Wiadomość została wysłana do",
      title: "Tytuł",
    },
    promotions: {
      alphabetical: "Alfabetyczny",
      alphanumeric: "Alfanumeryczny",
      amount_codes: "Liczba kodów",
      base_amount: "Kwota bazowa",
      exclude_code_after_usage: "Wypal kod po wykorzystaniu",
      bundle_name: "Nazwa pakietu",
      buy_to_receive: "Kup X aby otrzymać Y",
      code: "Kod",
      code_save_types: "Sposób generowania kodu",
      code_type: "Format kodu",
      club_members_slip_of_notepaper_content: "Treść fiszki",
      club_promotion_without_code: "Promocja clubowa bez kodu",
      description: "Opis kodu",
      discount: "Wysokość rabatu",
      discount_on_product: "Rabat na każdy pasujący produkt",
      discount_per_order: "Rabat na całe zamówienie",
      discount_type: "Typ rabatu",
      duration_of_the_promotion: "Czas trwania promocji",
      duration_of_the_slip_of_notepaper: "Czas trwania fiszki",
      enter_the_code: "Wpisz kod",
      examination_name: "Nazwa badania",
      excluded_services: "Lista wykluczeń",
      from: "Od",
      generate_codes: "Wiele kodów",
      has_slip_of_notepaper: "Czy wyświetlać fiszki?",
      import_code: "Importuj kod",
      import_codes: "Import pliku",
      import_services_discounts: "Importuj",
      infinitely_many_for_the_code: "Nieskończenie wiele dla kodu",
      is_for_club_members: "Promocja dla klubowiczów",
      is_for_partner: "Promocja dla partnera",
      is_header_in_first_row: "Plik zawiera nagłówki w pierwszym wierszu",
      is_omnibus: "Czy promocja podlega pod omnibus?",
      is_personal_codes: "Kody personalne",
      length_limit: "Ilość znaków kodu",
      limited_promotion: "Promocja ograniczona",
      name: "Nazwa kodu",
      new_code: "Nowy kod",
      newsletter_discount: "Zniżka na newsletter",
      number_of_promotions_for_the_code: "Ilość promocji dla kodu",
      number_of_promotions_for_the_user: "Ilość promocji dla użytkownika",
      numeric: "Numeryczny",
      override_default_club_promotion: "Nadpisuje domyślną promocje klubową 5%",
      priorities: {
        modal: {
          header: "Ustaw nową wartość",
          title: "Zmieniasz priorytet dla promocji: ",
        },
        priority_1: "1. najwyższy (pierwszy się wyświetli)",
        priority_2: "2",
        priority_3: "3",
        priority_4: "4",
        priority_5: "5. najniższy (ostatni się wyświetli)",
      },
      prefix: "Prefix kodu",
      preview_selected_services: "Podgląd wybranych badań i pakietów",
      priority: "Priorytet",
      select_all_bundles: "Wybierz wszystkie pakiety",
      select_all_examinations: "Wybierz wszystkie badania",
      single_code: "Pojedynczy kod",
      select_all_non_excluded: "Wybierz niewykluczone",
      stepper: {
        finish: "Zakończ",
        next: "Dalej",
        prev: "Wstecz",
      },
      suffix: "Sufix kodu",
      to: "Do",
      type: "Typ kodu",
      what_examination_are_you_looking_for: "Jakiego badania szukasz?",
      which_products_does_this_promotion_apply_to:
        "Jakich produktów dotyczy ta promocja?",
    },
    search_user: "Wyszukaj użytkownika",
  },
  auth: {
    birth_date: "Data urodzenia",
    checkboxes: {
      agree: "Oświadczam, że zapoznałem/zapoznałam się i akceptuję",
      agree_contact:
        "Wyrażam zgodę na kontaktowanie się ze mną przez ALAB laboratoria Sp. z o.o. z siedzibą w Warszawie",
      agree_contact_expand:
        " przy ul. Stępińskiej 22/30, 00-739 Warszawa, w celu omówienia warunków umowy za pomocą telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących zgodnie z ustawą z dnia 16 lipca 2004 r. – Prawo telekomunikacyjne czyli m.in. za pomocą telefonu komórkowego",
      agree_marketing:
        "Wyrażam zgodę na przetwarzanie moich danych osobowych, tj. adresu e-mail, w celu przesyłania newslettera drogą elektroniczną",
      agree_marketing_expand:
        " przez ALAB laboratoria Sp. z o.o. ul. Stępińska 22/30, 00-739 Warszawa, zgodnie z art. 10 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną (t.j. Dz. U. z 2017 r. poz. 1219). Oświadczam, iż zostałam/em poinformowany o moich uprawnieniach, o których szerzej mogę przeczytać w ",
      agree_processing_my_personal_data:
        "Wyrażam zgodę na przetwarzanie moich danych osobowych wskazanych w powyższym formularzu w celu założenia konta.",
      agree_processing_my_personal_data_expand:
        " Administratorem danych jest ALAB laboratoria Sp. z o.o. ul. Stępińska 22/30, 00-739 Warszawa. Oświadczam, że zostałam/em poinformowany o moich uprawnieniach, o których szerzej mogę przeczytać w",
      and: "oraz",
      information_obligation: "Obowiązku informacyjnym",
      privacy_policy: "Politykę prywatności",
      service: "serwisu",
      terms: "Regulamin",
      terms_of_service: "Regulamin serwisu",
    },
    commission_options: {
      d0p15: "0% dla lekarza, 15% dla pacjenta",
      d5p10: "5% dla lekarza, 10% dla pacjenta",
      d10p5: "10% dla lekarza, 5% dla pacjenta",
      d15p0: "15% dla lekarza, 0% dla pacjenta",
      other: "Inne",
    },
    country_code: "Numer kierunkowy",
    create_account: "Załóż konto",
    current_password: "Obecne hasło",
    day: "Dzień",
    email: "Adres e-mail",
    enter_birth_date: "Podaj datę urodzenia",
    enter_code: "Wpisz kod, który otrzymałeś w wiadomości SMS",
    enter_code_below: " Wpisz ten kod poniżej",
    enter_email_and_password: "Wpisz swój email i hasło,",
    enter_new_password: "Podaj nowe hasło do twojego konta",
    enter_pesel: "Wpisz swój pesel",
    enter_pesel_number: "Podaj numer PESEL",
    enter_phone_number: "Wpisz swój numer telefonu",
    first_name: "Imię",
    full_name: "Imię i nazwisko",
    gender: {
      f: "Kobieta",
      m: "Mężczyzna",
      title: "Płeć",
    },
    go_back_to_login: "Wróć do logowania",
    have_account: "Masz już konto?",
    identity_card: "Nr dowodu",
    last_name: "Nazwisko",
    login_by_pesel: "Zarejestruj się używając pesel",
    login_by_phone: "Zarejestruj się używając numeru telefonu",
    logout: "Wyloguj",
    month: "Miesiąc",
    no_pesel: " Brak numeru PESEL",
    not_have_account: "Nie masz jeszcze konta?",
    not_receive_code: "Kod do mnie nie dotarł",
    not_remember_password: "Nie pamiętasz hasła?",
    password: "Hasło",
    password_confirm: "Powtórz hasło",
    password_remind: "Przypomnij hasło",
    password_reset: "Resetuj hasło",
    patient_account: "do konta Pacjenta",
    patient_panel: "do panelu pacjenta",
    pay_for_examinations: "aby opłacić badania",
    pesel: "Pesel",
    phone: "Nr telefonu",
    phone_number: "Numer telefonu",
    pwz: "Nr PWZ",
    register: "Zarejestruj się",
    reset: "Reset hasła",
    reset_link_expired: "Twój link do resetu hasła wygasł",
    salary: "Wynagrodzenie",
    send_reset_link: "Na podany adres e-mail wyślemy link resetujący hasło",
    sent_reset_link: "Wysłaliśmy Ci SMS z kodem weryfikacyjnym pod numer",
    sent_reset_link_email:
      "Wysłaliśmy Ci wiadomość e-mail z linkiem do resetu hasła.",
    sent_reset_link_error:
      "Link został wysłany, odczekaj chwilę aby otrzymać nowy link.",
    set_password: "Ustaw hasło",
    sign_in: "Zaloguj się",
    sign_up: "Zarejestruj się",
    sms: "Kod SMS",
    specialist_panel: "do panelu specjalisty",
    to_create_account: "aby utworzyć konto w portalu",
    verify: "Weryfikuj",
    year: "Rok",
  },
  auto_reload: {
    auto: "Auto",
    button: "odśwież",
    menu: {
      "5m": "5m",
      "5s": "5s",
      "30s": "30s",
      "60s": "60s",
      off: "off",
    },
  },
  cart: {
    covid_service: "Usługa pielęgniarska COVID",
    details: "Szczegóły",
    discount_code: "Kod rabatowy",
    edit_referral: "Edytuj zlecenie",
    edit_referral_warning:
      "Edycja tego zlecenia spowoduje wystawienie nowego zlecenia i anulowanie obecnego zlecenia.",
    issue_referral: "Wystaw zlecenie",
    no_examinations: "Nie wybrałeś jeszcze żadnych badań do zlecenia.",
    nurse_service: "Usługa pielęgniarska",
    pay_referral: "Zapłać",
    selected_collection_point: "Wybrany Punkt Pobrań",
    selected_examinations: "Wybrane badania",
    total: "Łącznie",
    your_commission: "Twoje wynagrodzenie",
    your_discount: "Zniżka",
  },
  category: {
    bundles_categories: "kategorie pakietów",
    examinations_categories: "kategorie badań",
  },
  collection_facility: {
    collection_facility_text:
      "Ustaw dla którego punktu chcesz mieć pokazywany cennik badań laboratoryjnych. będziesz mógł go zmienić w każdej chwili w swoim profilu.",
    collection_facility_title: "Wybierz Punkt Pobrań",
    current_location_error:
      "Nie pozwolileś przeglądarce na pobranie lokalizacji. Spróbuj ponownie.",
    hide_filters: "Ukryj filtry",
    hide_list: "Ukryj listę",
    only_in_point: "Sprzedaż w Punkcie Pobrań",
    search_placeholder: "Miasto, ulica lub kod pocztowy",
    selected: "Wybrany",
    set_the_route: "Wyznacz trasę",
    show_filters: "Pokaż filtry",
    show_list: "Pokaż listę",
    show_on_map: "Pokaż na mapie",
  },
  collection_points: {
    additional_close: "Punkt NIECZYNNY",
    additional_info: "Dodatkowe informacje",
    additional_open: "Dodatkowe godziny otwarcia",
    filters: {
      is_40_plus: "Profilaktyka 40+",
      is_at_the_laboratory: "Przy laboratorium",
      is_children: "Przyjazny dzieciom",
      is_covid_private: "Przystosowany do COVID19",
      is_ginecology: "Ginekologiczny",
      is_sport: "ALAB Sport",
      is_swab: "Pobór wymazów",
      open_saturday: "Otwarty w sobotę",
      open_sunday: "Otwarty w niedzielę",
    },
  },
  dashboard: {
    commission_info:
      "Wynagrodzenie jest sumą kwot należnych do wypłaty za zlecenia zrealizowane",
    inaccessible_facility:
      "Twój Punkt Pobrań jest nieaktywny bądź nie można w nim wykonać badań.",
    inaccessible_facility_btn: "Zmień Punkt Pobrań",
  },
  doctor_status: {
    active: "Aktywny",
    all: "Wszystkie",
    blocked: "Zablokowany",
    deleted: "Usunięty",
    inactive: "Nieaktywny",
  },
  documents: {
    privacy_policy: "Polityka prywatności",
    terms: "Regulamin serwisu",
  },
  empty_list: {
    admins: "Lista adminów jest pusta.",
    warehouseman: "Lista magazynierów jest pusta.",
    doctors: "Lista lekarzy jest pusta.",
    invoices: "Lista faktur jest pusta.",
    patients: "Lista pacjentów jest pusta.",
    referrals: "Lista zleceń jest pusta.",
  },
  empty_services: {
    examinations: "Brak badań",
    packages: "Brak pakietów",
    search: "Brak wyszukiwanej frazy",
  },
  error: {
    clip_of_notepaper_start_date: {
      is_required_when: {
        clip_of_notepaper_end_date: {
          is_present: "Ustaw datę startu fiszki lub wyczyść datę końca fiszki",
        },
      },
      must_be_date_after_or_equal: {
        start_date:
          "Data startu fiszki nie może być wcześniejsza niż data startu promocji",
      },
      must_be_date_before_or_equal: {
        end_date:
          "Data startu fiszki musi być późniejsza niż data końca promocji",
        clip_of_notepaper_end_date:
          "Data startu fiszki nie może być późniejsza niż data końca fiszki",
      },
    },
    clip_of_notepaper_end_date: {
      is_required_when: {
        clip_of_notepaper_start_date: {
          is_present: "Ustaw datę końca fiszki lub wyczyść datę startu fiszki",
        },
      },
      must_be_date_after_or_equal: {
        clip_of_notepaper_start_date:
          "Data zakończenia fiszki nie może być wcześniejsza niż data startu fiszki",
        start_date:
          "Data zakończenia fiszki nie może być wcześniejsza niż data startu promocji",
      },
      must_be_date_before_or_equal: {
        end_date:
          "Data zakończenia fiszki nie może być późniejsza niż data zakończenia promocji",
      },
    },

    cf_turnstile_response: {
      required: "Weryfikacja CAPTCHA jest wymagana.",
    },
    accept_data_processing: {
      accepted: "Zgoda jest wymagana.",
    },
    accept_marketing: {
      accepted: "Zgoda jest wymagana.",
    },
    accept_terms: {
      accepted: "Zgoda jest wymagana.",
    },
    account_number: {
      invalid: "Numer rachunku bankowego jest niepoprawny.",
      invalid_checksum: "Numer rachunku bankowego jest niepoprawny",
      invalid_lenght: "Numer rachunku bankowego powinien posiadać 30 znaków.",
      required: "Numer rachunku bankowego jest wymagany.",
    },
    action_attempts: {
      user: {
        sms: {
          per_day: "Przekroczono limit dziennej ilości prób",
          per_hour: "Przekroczono limit godzinnej ilości prób",
        },
      },
    },
    agree_contact: {
      accepted: "Zgoda jest wymagana.",
    },
    agree1: {
      accepted: "Zgoda jest wymagana.",
    },
    barcode: {
      already_exists: "Posiadasz odebrane wyniki dla podanego kodu kreskowego",
      digits: "Wpisany kod kreskowy powinien mieć 10 cyf",
      digits_length_in: {
        "8_10": "Wpisany kod kreskowy powinien mieć 8 lub 10 cyfr",
      },
      not_found: "Nie znaleziono wyników dla podanych danych",
      numeric: "Wpisany kod kreskowy musi być liczbą",
      required: "Wpisany kod kreskowy jest wymagany",
    },
    birth_date: {
      incorrect: "Data urodzenia oraz pesel różnią się od siebie",
      invalid_date: "Data urodzenia nie jest poprawną datą.",
      invalid_user_exists:
        "Istnieje użytkownik którego data urodzenia i nr telefonu są inne niż podane.",
      must_be_a_date_before: "Nie można wybrać takiej daty urodzenia.",
      must_be_date_after_or_equal:
        "Data urodzenia musi być większa lub równa dacie 01.01.1900.",
      no_adult: "Data urodzenia dotyczy osoby dorosłej po 17 roku życia",
      required: "Data urodzenia jest wymagana.",
      required_if_empty: {
        pesel: "Pesel lub data urodzenia jest wymagana.",
      },
    },
    city: {
      required: "Miejscowość jest wymagana.",
    },
    code: {
      incorrect: "Podany kod jest nieprawidłowy.",
      required: "Kod sms jest wymagany.",
    },
    commission_option: {
      required: "Opcja wynagodzenia jest wymagana.",
      selected_invalid: "Opcja wynagrodzenia musi być jedną z opcji powyżej.",
    },
    commission_percent: {
      fail_discount_and_commission_sum:
        "Suma wynagrodzenia dla lekarza i rabatu pacjenta nie może przekroczyć 100%",
      must_be_less_than_100:
        "Wynagrodzenie dla lekarza musi być mniejsze niż 100%",
      must_be_less_than_or_equal_to_100:
        "Wynagrodzenie dla lekarza nie może przekroczyć 100%",
    },
    "curator id": {
      invalid: "Opiekun nie istnieje",
      required_if_empty: {
        "has curator":
          "Opiekun jest wymagany jeżeli zaznaczono że posiadasz swojego opiekuna.",
      },
    },
    current_password: {
      at_least_characters: "Obecne hasło musi mieć co najmniej 8 znaków.",
      incorrect: "Obecne hasło jest nieprawidłowe.",
      invalid_format:
        "Obecne hasło musi zawierać przynajmniej jedną małą literę, jedną dużą literę i jedną cyfrę.",
      required: "Obecne hasło jest wymagane.",
    },
    date: {
      at_least_characters: "Nie można wpisać starszego roku niż 2022",
    },
    email: {
      already_taken: "Podany email został już wykorzystany.",
      credentials_not_match: "Dane uwierzytelniające są nieprawidłowe.",
      email: "Email musi być poprawnym adresem email.",
      required: "Email jest wymagany.",
      selected_invalid: "Podany email nie istnieje w bazie.",
    },
    end_date: {
      invalid_date: "Data jest nieprawidłowa",
    },
    first_name: {
      required: "Imię jest wymagane.",
    },
    gender: {
      required: "Płeć jest wymagana.",
    },
    house_number: {
      required: "Numer budynku jest wymagana.",
    },
    identity_card: {
      required: "Nr dowodu jest wymagany.",
    },
    is_verify: "Konto z podanym numerem telefonu już istnieje.",
    keeper_id: {
      required_if_empty: {
        has_keeper:
          "Opiekun jest wymagany jeżeli zaznaczono że posiadasz swojego opiekuna.",
      },
    },
    last_name: {
      required: "Nazwisko jest wymagane.",
    },
    main_medical_category_id: {
      required: "Proszę wybrać kategorie.",
    },
    message: {
      required: "Treść wiadomości jest wymagana.",
    },
    name: {
      already_taken: "Ta nazwa już jest użyta",
      required: "Nazwa jest wymagana.",
    },
    national_number: {
      required: "Nr telefonu jest wymagany",
    },
    password: {
      at_least_characters: "Hasło musi mieć co najmniej 8 znaków.",
      invalid_format:
        "Hasło musi zawierać przynajmniej jedną małą literę, jedną dużą literę i jedną cyfrę.",
      required: "Hasło jest wymagane.",
    },
    password_confirm: {
      must_match: "Hasło i potwierdzenie hasła muszą być takie same.",
      required: "Potwierdzenie hasła jest wymagane.",
    },
    patient_age: {
      underage:
        "Przepraszamy na chwile obecną jest możliwość wystawienia zleceń wyłącznie na osoby pełnoletnie",
    },
    patient_discount_percent: {
      must_be_less_than_100: "Rabat dla pacjenta musi być mniejszy niż 100%",
      must_be_less_than_or_equal_to_100:
        "Rabat dla pacjenta nie może przekroczyć 100%",
    },
    pesel: {
      already_taken: "Podany pesel został już wykorzystany.",
      birth_date_diffrent: "Data urodzenia oraz pesel różnią się od siebie",
      digits: "Pesel musi mieć długość 11.",
      incorrect: "Nie możemy odnaleźć użytkownika o podanym peselu.",
      invalid: "Niepoprawny numer pesel.",
      invalid_user_exists:
        "Istnieje użytkownik którego pesel i nr telefonu są inne niż podane.",
      required: "Pesel jest wymagany.",
      required_if_empty: {
        birth_date: "Pesel lub data urodzenia jest wymagana.",
      },
      required_when_not_present: {
        phone_number: "Numer telefonu lub pesel jest wymagany.",
      },
    },
    pesel_invalid: "Pesel dotyczy osoby dorosłej po 17 roku życia",
    phone_is_valid: {
      accepted: "Niepoprawny numeru telefonu.",
    },
    pwz: {
      required: "Pwz jest wymagane.",
    },
    company_name: {
      required: "Nazwa firmy / przychodni jest wymagana.",
    },
    nip: {
      required: "Nip jest wymagany.",
      digits: "Nip musi mieć długość 10.",
      invalid: "NIP nie spełnia wymagań",
    },
    phone_number: {
      accepted: "Błędny numer telefonu",
      already_taken: "Podany numer telefonu został już wykorzystany.",
      choose_country: "Wybierz kraj",
      digits: "Nr telefonu musi mieć długość 9.",
      incorrect: "Nie możemy odnaleźć użytkownika o podanym nr telefonu.",
      required: "Nr telefonu jest wymagany.",
      required_when_not_present: {
        pesel: "Numer telefonu lub pesel jest wymagany.",
      },
    },
    postal_code: {
      required: "Kod pocztowy jest wymagany.",
    },
    promotions: {
      amount_codes: {
        required: "Liczba kodów jest wymagana.",
        numeric: "Liczba kodów musi być liczbą.",
        withinCodeSpace:
          "Liczba kodów jest zbyt duża dla wybranego formatu i długości kodu. Zwiększ ilość znaków kodu lub zmniejsz liczbę kodów.",
      },
      code: {
        required: "Kod jest wymagany.",
      },
      code_save_types: {
        required: "Sposób generowania kodu jest wymagany.",
      },
      code_type: {
        required: "Format kodu jest wymagany.",
      },
      description: {
        required: "Opis kodu jest wymagany.",
      },
      discount: {
        maxValue: "Wysokość rabatu nie może przekraczać 100%",
        minValue: "Wysokość rabatu nie być mniejsza od 0",
        must_be_less_than_100: "Wysokość rabatu nie może przekraczać 100%",
        must_be_less_than_or_equal_to_100:
          "Wysokość rabatu nie może przekraczać 100%",
        required: "Wysokość rabatu jest wymagana.",
        numeric: "Wysokość rabatu musi być liczbą.",
        greaterThanZero: "Rabat kwotowy musi być większy od 0.",
      },
      file: {
        required: "Import pliku jest wymagany.",
      },
      length_limit: {
        required: "Ilość znaków kodu jest wymagana.",
        numeric: "Ilość znaków kodu musi być liczbą.",
        minValue: "Ilość znaków kodu musi być większa od 0.",
      },
      minimum_order_amount: {
        required: "Kwota bazowa jest wymagana.",
        numeric: "Kwota bazowa musi być liczbą.",
      },
      name: {
        required: "Nazwa kodu jest wymagana.",
      },
      packages: {
        minLength:
          "Promocja musi obejmować przynajmiej jedno badanie lub pakiet.",
      },
      prefix: {
        required: "Prefix kodu jest wymagany.",
      },
      priority: {
        required: "Promocja musi mieć określony priorytet",
      },
      services: {
        minLength:
          "Promocja musi obejmować przynajmiej jedno badanie lub pakiet.",
      },
      start_date: {
        beforeEndDate:
          "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
      },
      clip_of_notepaper_start_date: {
        required: "Pole startu fiszki jest wymagane",
        beforeEndDate:
          "Data startu fiszki musi być wcześniejsza niż data zakończenia fiszki.",
        withinPromotionRange:
          "Czas trwania fiszki musi zawierać się w czasie trwania promocji.",
      },
      clip_of_notepaper_end_date: {
        required: "Pole zakończenia fiszki jest wymagane",
        withinPromotionRange:
          "Czas trwania fiszki musi zawierać się w czasie trwania promocji.",
      },
      suffix: {
        required: "Sufix kodu jest wymagany.",
      },
      type: {
        required: "Typ kodu jest wymagany.",
      },
      type_discount: {
        required: "Typ rabatu jest wymagany.",
      },
      use_limit: {
        numeric: "Liczba promocji dla kodu musi być liczbą.",
        minValue: "Liczba promocji dla kodu nie może być mniejsza od 0.",
      },
      use_limit_per_user: {
        required: "Ilość promocja dla użytkownika jest wymagana.",
        numeric: "Ilość promocji dla użytkownika musi być liczbą.",
      },
    },
    start_date: {
      invalid_date: "Data jest nieprawidłowa",
    },
    street: {
      required: "Ulica jest wymagana.",
    },
    title: {
      required: "Tytuł jest wymagany.",
    },
  },
  error_page: {
    refresh: "Odśwież",
    ups: "Ups, coś poszło nie tak. Poczekaj chwilę lub spróbuj odświeżyć stronę.",
  },
  examinations: {
    no_examinations: "Brak badań.",
    no_packages: "Brak pakietów.",
    package: "pakiet",
    pp_only: "Dostępne w Punkcie Pobrań",
    test_not_available_at_selected_point:
      "Badanie niedostępne w wybranym Punkcie Pobrań",
    change: "Zmień",
  },
  feature: {
    alab_sport: "ALAB Sport",
    ask_for_examination: "Poproś o badanie",
    block_patients: "Blokowanie pacjentów",
    cart_pay_for_doctor_referral: "Koszyk opłać zlecenie od lekarza",
    check_phone_number: "Weryfikacja numeru telefonu",
    collection_points_filters: "Filtry dla Punktów Pobrań",
    doctor_own_packages: "Pakiety własne lekarza",
    excel: "Eksport do Excel",
    invoice_data: "Dane do faktury",
    login_by_old_system: "Logowanie przez stary system",
    patient_own_packages: "Pakiety własne pacjenta",
    results_crash_info: "Informacja o awarii wyników",
    share_examinations_modal: "Modal udostępniania badań",
    show_new_catalog: "Nowy katalog badań",
    v2_laboratory_order: "Zlecenie laboratoryjne v2",
  },
  filters: {
    commission: "Wynagrodzenie",
    company_name: "Nazwa przychodni",
    cost: "Koszt badania",
    date_of_issue: "Data wystawienia",
    doctor: "Lekarz",
    patient: "Pacjent",
    patient_discount_percent: "Procent rabatu",
    price: "Cena",
    referral_number: "Numer zlecenia",
    status: "Status",
    type: "Typ",
    invoice: "Faktura",
  },
  gatekeeper: {
    access: "Dostęp",
    admin: {
      create: "Dodaj Admina",
      data: "Dane Admina",
      edit: "Zmień Admina",
    },
    warehouse: {
      create: "Dodaj Magazyniera",
      data: "Dane Magazyniera",
      edit: "Zmień Magazyniera",
    },
    admins: "Lista Adminów",
    blocked_access: "Zablokowany dostęp",
    empty_access: "Brak dostępów",
    gatekeeper: {
      create: "Dodaj Gatekeepera",
      data: "Dane Gatekeepera",
      edit: "Zmień Gatekeepera",
    },
    gatekeepers: "Lista Gatekeeperów",
    warehouseman: "Lista Magazynierów",
    inactive_access: "Nieaktywne konto",
    me: "Zalogowane konto",
    search: "Wyszukaj",
    table: {
      created_at: "Data utworzenia",
      updated_at: "Data modyfikacji",
    },
  },
  homepage: {
    about_us: "O nas",
    admin: "Administrator",
    cart: "Koszyk",
    catalog_of_examinations: "Katalog badań",
    choose_from:
      "Wybierz spośród ponad 3500 badań, 68 kategorii badań i pakietów.",
    cms: "CMS",
    collection_points_1: "Ponad",
    collection_points_2: "Punktów Pobrań",
    contact: "Kontakt",
    cpr: "CRP",
    creatynine: "Kreatynina",
    discount_1: "Do",
    discount_2: "Na wszystkie pakiety badań",
    discount_3: "Sprawdź",
    doctor: "Lekarz",
    faq: "FAQ",
    glucose: "Glukoza",
    highest_quality_research:
      "Wykonaj najwyższej jakości badania w całej Polsce",
    iron: "Żelazo",
    join_special_actions:
      "Dołącz do akcji specjalnych, korzystaj z promocji, twórz pakiety własne oraz używaj konta pacjenta z historią i analizami wyników badań.",
    mercury_in_the_blood: "Rtęć we krwi",
    morphology: "Morfologia",
    my_referrals: "Moje zlecenia",
    patient: "Pacjent",
    potassium: "Potas",
    research_every_year_1: "Ponad",
    research_every_year_2: "mln",
    research_every_year_3: "badań rocznie",
    shop: "Sklep",
    shortcuts: "Na skróty",
    what_examination_are_you_looking_for: "Jakiego badania szukasz?",
    years_on_the_market_1: "Ponad",
    years_on_the_market_2: "lat",
    years_on_the_market_3: "na rynku",
  },
  layouts: {
    examintons_list: "Katalog badań",
    issue_referral: "Wystaw zlecenie",
    main_page: "Strona główna",
    own_packages: "Pakiety własne",
    patient_list: "Lista pacjentów",
    referral_history: "Historia zleceń",
  },
  medical_categories: {
    a_doctor_in_the_process_of_specialization: "Lekarz w trakcie specjalizacji",
    all: "Wszystkie",
    podiatrist: "Podolog",
    trichologist: "Trycholog",
    allergist: "Alergolog",
    andrologist: "Androlog",
    anesthesiologist: "Anestezjolog",
    angio_surgeon: "Angiochirurg",
    angiologist: "Angiolog",
    audiologist: "Audiolog",
    bariatra: "Bariatra",
    cardiac_surgeon: "Kardiochirurg",
    cardiologist: "Kardiolog",
    child_psychiatrist: "Psychiatra dziecięcy",
    child_psychologist: "Psycholog dziecięcy",
    coach: "Trener",
    dental_hygienist: "Higienistka stomatologiczna",
    dental_surgeon: "Chirurg stomatologiczny",
    dentist: "Stomatolog",
    dermatologist: "Dermatolog",
    diabetologist: "Diabetolog",
    diagnostic: "Diagnostyk",
    dietician: "Dietetyk",
    doctor_of_emergency_medicine: "Lekarz Medycyny Ratunkowej",
    doctor_without_specialization: "Lekarz bez specjalizacji",
    endocrinologist: "Endokrynolog",
    family_doctor: "Lekarz rodzinny",
    forensic_expert: "Biegły Sądowy",
    gastrologist: "Gastrolog",
    geneticist: "Genetyk",
    geriatrician: "Geriatra",
    gynecologist: "Ginekolog",
    hematologist: "Hematolog",
    hepatologist: "Hepatolog",
    histopathologist: "Histopatolog",
    hypertensiologist: "Hipertensjolog",
    immunologist: "Immunolog",
    infectious_diseases_physician: "Lekarz Chorób Zakaźnych",
    internist: "Internista",
    laryngologist: "Laryngolog",
    list: "Specjalizacje",
    logopedist: "Logopeda",
    main_category: "Specjalizacja",
    maxillofacial_surgeon: "Chirurg Szczękowo-Twarzowy",
    midwife: "Położna",
    neonatologist: "Neonatolog",
    nephrologist: "Nefrolog",
    neurologist: "Neurolog",
    neurosurgeon: "Neurochirurg",
    nurse: "Pielęgniarka",
    obstetrician: "Położnik",
    occupational_medicine_physician: "Lekarz Medycyny Pracy",
    oncologist: "Onkolog",
    ophthalmologist: "Okulista",
    optometrist: "Optometrysta",
    orthodontist: "Ortodonta",
    orthopedist: "Ortopeda",
    orthoptist: "Ortoptysta",
    osteopath: "Osteopata",
    pathomorphologist: "Patomorfolog",
    pediatric_allergist: "Alergolog dziecięcy",
    pediatric_cardiologist: "Kardiolog dziecięcy",
    pediatric_dentist: "Stomatolog dziecięcy",
    pediatric_dermatologist: "Dermatolog Dziecięcy",
    pediatric_diabetologist: "Diabetolog Dziecięcy",
    pediatric_endocrinologist: "Endokrynolog Dziecięcy",
    pediatric_gastrologist: "Gastrolog Dziecięcy",
    pediatric_gynecologist: "Ginekolog dziecięcy",
    pediatric_hematologist: "Hematolog dziecięcy",
    pediatric_laryngologist: "Laryngolog dziecięcy",
    pediatric_nephrologist: "Nefrolog dziecięcy",
    pediatric_neurologist: "Neurolog dziecięcy",
    pediatric_neurosurgeon: "Neurochirurg dziecięcy",
    pediatric_oncologist: "Onkolog dziecięcy",
    pediatric_ophthalmologist: "Okulista dziecięcy",
    pediatric_orthopedist: "Ortopeda dziecięcy",
    pediatric_physiatrist: "Fizjoterapeuta Dziecięcy",
    pediatric_pulmonologist: "Pulmonolog dziecięcy",
    pediatric_rheumatologist: "Reumatolog dziecięcy",
    pediatric_surgeon: "Chirurg dziecięcy",
    pediatric_urologist: "Urolog dziecięcy",
    pediatrician: "Pediatra",
    perinatologist: "Perinatolog",
    phlebologist: "Flebolog",
    physiatrist: "Fizjoterapeuta",
    physician_of_medical_rehabilitation: "Lekarz Rehabilitacji Medycznej",
    plastic_surgeon: "Chirurg plastyczny",
    proctologist: "Proktolog",
    prosthetist: "Protetyk",
    psychiatrist: "Psychiatra",
    psycho_oncologist: "Psychoonkolog",
    psychologist: "Psycholog",
    psychotherapist: "Psychoterapeuta",
    psychotraumatologist: "Psychotraumatolog",
    pulmonologist: "Pulmonolog",
    radiation_therapist: "Radioterapeuta",
    radiologist: "Radiolog",
    rheumatologist: "Reumatolog",
    sexologist: "Seksuolog",
    specialist_in_aesthetic_medicine: "Specjalista Medycyny Estetycznej",
    sports_doctor: "Lekarz sportowy",
    sports_medicine_physician: "Lekarz medycyny sportowej",
    surgeon: "Chirurg",
    thoracic_surgeon: "Chirurg klatki piersiowej",
    transplantologist: "Transplantolog",
    ultrasonograph: "Ultrasonograf",
    urologist: "Urolog",
    vascular_surgeon: "Chirurg naczyniowy",
    venereologist: "Wenerolog",
  },
  messages: {
    activation_sms: {
      failure: "Wystąpił problem z wysyłaniem wiadomości SMS",
      success: "Pomyślnie wysłano kod sms",
    },
    cancel_referral: {
      failure: "Wystąpił błąd. Zlecone badania nie zostały anulowane.",
      success: "Zlecone badania zostały anulowane.",
    },
    code: {
      resend: "Kod został wysłany ponownie.",
      resend_error: "Wystąpił błąd podczas wysyłania kodu.",
    },
    delete: {
      failure: "Wystąpił problem podczas usuwania",
      success: "Pomyślnie usunięto",
    },
    download: {
      failure: "Wystąpił błąd podczas pobierania pliku.",
      no_files: "Nie znaleziono plików do pobrania.",
      no_invoice: "Nie znaleziono faktury do pobrania.",
    },
    invoice: {
      send_success: "Faktura została wysłana pomyślnie",
      send_failure: "Wystąpił błąd podczas wysyłania faktury",
      mark_paid_success: "Faktura została oznaczona jako opłacona",
      mark_paid_failure:
        "Wystąpił błąd podczas oznaczania faktury jako opłaconej",
    },
    edit: {
      failure: "Wystąpił błąd. Zmiany nie zostały zapisane.",
      success: "Zmiany zostały zapisane.",
    },
    edit_amd_send_seferral: {
      success: "Zmiany zostały zapisane oraz ponownie wysłano zlecenie.",
    },
    fetch: {
      failure: "Wystąpił błąd podczas pobierania danych.",
      success: "Pobrano pomyślnie.",
    },
    generate: {
      failure: "Wystąpił problem podczas dodawnia",
      success:
        "Pomyślnie dodano do kolejki oczekujących plików na wygenerowanie.",
    },
    payment_token: {
      failure:
        "Wystąpił błąd. Spróbuj ponownie albo skontaktuj się z administratorem.",
    },
    permission: {
      failure: "Nie można wykonać.",
      forbidden:
        "Konto jest nieaktywne, skontaktuj się z biurem obsługi klienta.",
    },
    save: {
      failure: "Wystąpił błąd. Nie udało się zapisać.",
      success: "Zapisano pomyślnie.",
    },
    send: {
      failure: "Wystąpił błąd. Nie udało się wysłać wiadomości.",
    },
    sms: {
      failure: "Wystąpił błąd. Sms nie został wysłany ponownie.",
      success: "Sms został wysłany ponownie.",
    },
    toggle_excluded_from_promotions: {
      failure: "Wystąpił błąd. Nie udało się zmienić statusu usługi.",
    },
  },
  no: "Nie",
  not_found_page: {
    error: "Błąd",
    go_back: "Wróć na stronę główną",
    not_found: "Nie znaleziono strony",
  },
  own_packages: {
    add_examinations_to_package: "Dodaj kolejne badanie do pakietu",
    add_new_own_package: "Dodaj nowy pakiet własny",
    add_to_cart: "Dodaj do koszyka",
    add_to_cart_selected: "Dodaj wybrane badania",
    add_to_new_own_package: "Dodaj do nowego pakietu własnego",
    add_to_own_package: "Dodaj do pakietu własnego",
    all_examinations: "Wszystkie badania",
    create_first_own_examination_package: "Stwórz swój pierwszy pakiet badań",
    create_first_own_package:
      "Utwórz swój pierwszy pakiet własny wpisując poniżej jego nazwę.",
    create_own_examination_package: "Stwórz własny pakiet badań",
    create_own_package: "Stwórz pakiet własny",
    delete_new_own_package: "Usuń pakiet własny",
    delete_new_own_package_confirm: "Czy na pewno chcesz usunąć pakiet",
    delete_package: "Usuń pakiet",
    edit_own_package: "Edycja nazwy pakietu własnego",
    edit_package_name: "Edytuj nazwę pakietu",
    examination_details: "Szczegóły badania",
    examination_packages: "Pakiety badań",
    examinations: "badania",
    examinations_counter: "badań",
    faster_access:
      "Będziesz miał szybszy dostęp do badań których często szukasz",
    name_own_package: "Nazwa pakietu własnego",
    no_examinations_in_package_1:
      "Nie dodałeś jeszcze żadnych badań do swojego pakietu",
    no_examinations_in_package_2: "Jak dodać badania do pakietu własnego?",
    no_examinations_in_package_3:
      "Przy każdym badaniu (pod jego nazwą), znajduje się niebieska gwiazdka z linkiem, która umożliwia dodania wybranego badania do pakietu własnego",
    no_examinations_in_package_4:
      "Kliknij w nią i wybierz do którego pakietu chcesz dodać badanie. Pamiętaj, że możesz stworzyć nieskończenie wiele pakietów, warto tylko nazywać je w zrozumiały i charakterystyczny dla Ciebie sposób",
    no_examinations_in_package_5: "Przejdź do listy z wyborem badań",
    no_examinations_in_package_6:
      "Do pakietu własnego nie można dodawać pakietów z oferty ALAB, możliwe jest dodawanie pojedynczych badań",
    other_examinations: "Pozostałe badania",
    own_packages: "Pakiety własne",
    package_details: "Szczegóły pakietu",
    shorter_working_time: "Skrócisz czas swojej pracy i wystawiania zleceń",
    thanks_to_own_packages: "Dzięki pakietom własnym",
    update_own_package: "Edytuj pakiet własny",
    your_own_packages: "Twoje pakiety własne",
  },
  pages: {
    account: "Ustawienia konta",
    admins: "Lista Adminów",
    warehouseman: "Lista magazynierów",
    clientinvoices: "Faktury klientów",
    curators: "Opiekuni",
    doctors: "Lekarze",
    gatekeepers: "Lista Gatekeeperów",
    guests: "Niezarejestrowani",
    history_orders: "Historia zleceń",
    invoices: "Faktury",
    live_sales: "Sprzedaż live",
    live_sales_tv: "Widok TV",
    my_settlements: "Moje rozliczenia",
    patients: "Pacjenci",
    promotions: "Promocje",
    raports: "Raporty",
    referralErrors: "Logi błędów",
    referrals: "Zlecenia",
    reports: "Raporty",
    users: "Użytkownicy",
    your_referrals: "Twoje zlecenia",
    features: "Funkcjonalności",
    excluded_services: "Lista wykluczeń",
    withdrawal_contracts: "Lista odstąpień od umowy",
  },
  patient_details: {
    archive: "Archiwum wyników",
    archive_order_delete_confirm_info:
      "Czy na pewno chcesz usunąć wyniki o numerze: {number}?",
    archive_order_delete_confirm_title:
      "Potwierdzenie usunięcia wyników z archiwum",
    consents: {
      awaiting_consent: "Oczekuje na zgodę",
      browser: "Przeglądarka",
      consent_to_access_to_test_results: "Zgoda na dostęp do wyników badań",
      consent_to_data_processing: "Zgoda na przetwarzanie danych",
      current_consent: "Aktualna zgoda",
      date_of_consent: "Data zgody",
      date_of_statement: "Data oświadczenia",
      declaration_accepted: "Oświadczenie zaakcepotwane",
      declarations: "Oświadczenia",
      doctor: "Lekarz",
      end_date_of_consent: "Data zakończenia zgody",
      history_of_consents: "Historia zgód",
      ip_address: "Adres IP",
      mame_of_child: "Imię i nazwisko dziecka",
      marketing_consent: "Zgoda marketingowa",
      no: "Nie",
      no_consents: "Brak zgód",
      patient_consents: "Zgody pacjenta",
      source: "Źródło",
      sources: {
        "order-agreement": "Zamówienie",
        "registration-agreement": "Rejestracja",
        system: "Wpis systemowy",
        "user-account-agreement": "Konto usera",
        "user.com": "Zmiana w user.com",
      },
      yes: "Tak",
    },
    consents_and_declarations: "Zgody i oświadczenia",
    edit_data: "Edytuj dane",
    show_data: "Podgląd danych",
    full_name: "Imie i nazwisko",
    import_results: "Dodaj wyniki",
    kid: "Dziecko",
    order_history: "Historia zleceń",
    parent: "Rodzic",
    patient_delete_confirm_info: "Czy na pewno chcesz usunąć pacjenta: {name}?",
    patient_delete_confirm_title: "Potwierdzenie usunięcia pacjenta",
    patient_info: "Informacje o pacjencie",
    registered_at: "Data rejestracji",
    role: "Rola",
    send_sms_to_activate_account: "Wyślij sms do aktywacji konta",
    show_user: "Przejdź do profilu",
    status: "Status",
    user_info: "Informacje o użytkowniku",
  },
  patient_discount_percent: {
    all: "Wszystkie",
    fifteen: "15 %",
    five: "5 %",
    ten: "10 %",
    zero: "0 %",
  },
  patients: {
    edit: "Edytuj pacjenta",
    edit_patient: "Edytuj wybranego pacjenta",
    edit_patient_block:
      "Dane Pacjenta mogą być zmieniane tylko przez Obsługę Klienta",
    no_patients: "Nie posiadasz jeszcze pacjentów.",
    patient_in_system_assign_to_another_doc:
      "Pacjent znajduje się już w naszym systemie",
    request_access_to_historical_test_results:
      "W celu przeprowadzenia lepszej diagnostyki poproś o dostęp do historycznych wyników badań",
  },
  payment: {
    advance: "Oczekiwanie na potwierdzenie płatności.",
    canceled: "Płatność anulowana.",
    go_to_dashboard: "Przejdź do panelu głównego",
    made: "Platność zrealizowana.",
    retry_payment: "Ponów płatność",
    returned: "Płatność zwrócona.",
  },
  referral_status: {
    admin: {
      all: "Wszystkie",
      canceled: "Anulowane",
      completed: "Zrealizowane",
      issued: "Wystawione",
      paid: "Opłacone",
      visit_data_missing: "Problem z wizytą domową!",
    },
    doctor: {
      all: "Wszystkie",
      canceled: "Anulowane",
      completed: "Zrealizowane",
      issued: "Wystawione",
      paid: "Opłacone",
    },
    patient: {
      canceled: "Anulowane",
      completed: "Zrealizowane",
      issued: "Nowe",
      paid: "Opłacone",
    },
  },
  referral_type: {
    all: "Wszystkie",
    archive: "Archiwum HBZ",
    doctor: "AlabDoctor",
    home: "Alab w domu",
    laboratory: "Laboratorium",
    sport: "AlabSport",
    withoutSport: "bez AlabSportu",
    delivery: "Wysyłkowe",
  },
  referrals: {
    active: "Aktywnie wyświetlane zamówienie",
    // commission: "Twoje wynagrodzenie",
    add_or_choose_patient:
      "Uzupełnij dane nowego pacjenta lub znajdź na liście swoich pacjentów",
    added: "Dodano",
    additionally_examinations:
      "Jeżeli chcesz, możesz dodatkowo wykonać inne badania",
    average_number_of_referrals: "Śr. ilość zleceń",
    average_price_of_referral: "Śr. cena zlecenia",
    browser: "Przeglądarka",
    cancel_issued_referral: "Anuluj zlecone badania",
    change: "Zmień dane i wyślij zlecenie ponownie",
    choose_examinations: "Dobierz badania",
    choose_patient: "Wybierz pacjenta z listy",
    collection_facilities: "Punkty Pobrań",
    collection_facilities_text:
      "Sprawdź, w którym Punkcie Pobrań Twój pacjent może zrealizować zlecenie",
    collection_point: "Punkt pobrań",
    commission: {
      account_number: "Numer konta",
      amount: "Kwota prowizji",
      company: "Nazwa firmy",
      nip: "NIP",
      title: "Wynagrodzenie Doktora",
    },
    commission_after_purchase:
      "Wynagrodzenie naliczy się po wykupieniu zlecenia przez pacjenta i zrealizowaniu badań laboratoryjnych",
    commissioned_examinations: "Zlecone badania",
    date_of_issue: "data wystawienia",
    date_of_test: "data wykonania badań",
    details: "Szczegóły",
    discount: {
      combines_with_promotions: "Łączy się z innymi promocjami",
      duration: "Czas trwania promocji",
      own_package_discount: "Zniżka własnego pakietu",
      title: "Użyty kod rabatowy",
      type: "Typ promocji",
      value: "Wartość rabatowa",
    },
    doctor: "lekarz",
    edit_issued_referral: "Edytuj zlecone badania",
    email: "Adres e-mail",
    enter_study_name: "Wpisz nazwę badania",
    exact_price: "Dokładną cenę poznasz po wyborze Punktu Pobrań",
    examination_findings: "Wyniki badań",
    examination_findings_text:
      "Wyniki badań będą dostępne po zrealizowaniu zlecenia",
    examinations: "badania",
    full_name: "Imię i nazwisko",
    gender: "Płeć",
    guest_user: "Zamawiający (bez rejestracji)",
    hl7: {
      empty: "Brak id zamówiania w HL7",
      order_id: "Id zamówienia w HL7",
      title: "HL7",
    },
    home_visit_address: "Adres wizyty domowej",
    ip_address: "Adres IP",
    issue_referral: "Wystaw zlecenie na badanie",
    issue_referrals: "Wystaw zlecenie",
    issued_at: "Data i godzina zamówienia",
    issued_on: "Wystawiono dnia",
    issued_referral_text_part1:
      "Wystawiłeś zlecenie. Wysłaliśmy SMS do pacjenta z instrukcją realizacji zlecenia.",
    issued_referral_text_part2:
      "Otrzymasz wynagrodzenie, kiedy pacjent opłaci zlecenie, wykona badania i otrzyma wyniki.",
    mpk: "MPK",
    my_patient_list: "Lista moich pacjentów",
    no_collection_point: "Brak określonego punktu pobrań",
    no_patient: "Brak danych pacjenta",
    no_referrals: "Nie posiadasz wystawionych zleceń.",
    number: "Zlecenie nr",
    number_of_referrals: "Ilość zleceń",
    number_short: "nr",
    ordered_examinations: "Zlecone badania",
    package: "pakiet",
    patient: "Pacjent",
    patient_list: "Lista pacjentów",
    patient_modal_tip:
      "Uzupełnij telefon i PESEL pacjenta. Jeśli pacjent istnieje - zostanie automatycznie uzupełnione Imię i Nazwisko. Jeśli Pacjent nie zostanie znaleziony, będzie można uzupełnić jego Imię i Nazwisko",
    payment: "Płatność",
    payments: {
      amount: "Kwota",
      confirmed: "Potwierdzona płatność",
      created_at: "Data utworzenia",
      currency: "Waluta",
      no_payment: "Brak zarejestrowanej płatności.",
      order_id: "Numer zamówienia",
      title: "Płatności",
    },
    pesel: "Pesel",
    phone_number: "Nr telefonu",
    popular_examinations: "Najczęściej wybierane badania",
    price_facility_payment: "Cena przy płatności w Punkcie Pobrań Alab",
    price_online_payment:
      "Cena przy płatności internetowej w serwisie ALAB Online.pl",
    print_referral: "Drukuj zlecenie",
    pwz: "Numer PWZ",
    receive_VAT_invoice: "Chcę otrzymać fakturę VAT",
    referral: "Zlecenie",
    referral_for_examination: "Zlecenie badań laboratoryjnych",
    referral_for_examination_text:
      "Wydrukowane zlecenie Twój pacjent może zrealizować bezpośrednio w Punkcie Pobrań ALAB laboratoria. Brak możliwości płatności w punkcie. Płatność tylko ONLINE.",
    search_patient: "Wpisz imię, nazwisko, pesel lub nr telefonu",
    search_referral_patient: "Wpisz imię lub nazwisko",
    see_collection_facilities: "Zobacz Punkty Pobrań",
    see_results: "Zobacz wyniki badań",
    send_sms_again: "Wyślij sms ponownie",
    visit_address: {
      title: "Adres Wizyty",
      street: "Ulica",
      home_number: "Numer domu",
      premises_number: "Numer lokalu",
      zip_code: "Kod pocztowy",
      city: "Miasto",
      level: "Piętro",
      gate_code: "Kod do domofonu",
      additional_comments: "Dodatkowe uwagi",
    },
    table: {
      city: "Miasto",
      code: "Kod pocztowy",
      commission: "Twoje wynagrodzenie",
      cost: "Koszt badania",
      date: "Data",
      doctor_commission_percent: "Twoje wynagrodzenie",
      full_name: "Imię i nazwisko",
      id: "Id zlecenia",
      identity_card: "Nr dowodu",
      number_of_examinations: "Ilość badań",
      patient_discount: "Rabat pacjenta",
      patient_discount_percent: "Rabat pacjenta",
      pesel: "Pesel",
      phone: "Telefon",
      show: "Zobacz zlecenie",
      show_patient: "Zobacz pacjenta",
      status: "Status",
      street: "Ulica",
    },
    tabs: {
      examinations: "Badania",
      packages: "Pakiety",
    },
    to_receive_an_invoice:
      "Aby otrzymać fakturę prosimy kontaktować się na adres email:",
    top_doctors: "Lekarze, którzy wystawili zlecenia na największą sumę:",
    unavailable: "Niedostępne",
    unknown: "Szczegóły badania chwilowo niedostępne",
    user: "Zamawiający (zarejestrowany użytkownik)",
    waiting_for_commissions: "Oczekiwanie na wynagrodzenie",
    waiting_for_payment: "Oczekiwanie na płatność",
    workbeep: {
      confirmed: "Potwierdzona rezerwacja",
      no_address: "Brak adresu wizyty domowej",
      no_confirmation: "Brak potwierdzenia rezerwacji",
      title: "Alab w domu",
      visit_date: "Data wizyty domowej",
      workbeep_id: "Id rezerwacji w workbeep",
    },
    your_facility: "Twój Punkt Pobrań",
  },
  reports: {
    changelog: "Lista zmian",
    create: "Utwórz raport",
    date: "Data",
    download: "Pobierz",
    empty_list: "Brak raportów do wyświetlenia.",
    end_at: "Raport do",
    format: "Format",
    generate_new: "Wygeneruj raport",
    list: "Lista Twoich raportów",
    refresh: "Odśwież listę raportów",
    select: "Zakres danych",
    source: "Źródła",
    start_at: "Raport od",
    status: "Status",
    statuses: {
      active: "OK",
      deleted: "Skasowany",
      error: "Error",
      "in-progress": "W trakcie generowania...",
      wait: "Oczekuje w kolejce",
    },
    type: "Typ raportu",
    types: {
      "full-summary-of-day-paid": "Szczegółowe zestawienie dzienne: opłacone",
      "full-summary-of-day-unpaid":
        "Szczegółowe zestawienie dzienne: nieopłacone",
      "summary-of-day-paid": "Zestawienie dzienne: opłacone",
      "summary-of-day-unpaid": "Zestawienie dzienne: nieopłacone",
      "summary-of-examinations-and-packages":
        "Zestawienie po badaniach i pakietach",
      "summary-of-examinations-and-packages-for-year":
        "Zestawienie po badaniach i pakietach roczne",
      "summary-of-facility": "Zestawienie punktu pobrań",
      "summary-of-month": "Zestawienie miesięczne punktu pobrań",
      "summary-of-patients": "Zestawienie po pacjentach",
      "summary-of-withdrawal": "Zestawienie odstąpienia od umowy",
      "doctors-orders": "Raport sprzedaży Doctor",
    },
  },
  results: {
    back_to_referral: "Powrót do zlecenia",
    choose_examination: "Wybierz badanie, żeby wyświetlić wyniki",
    download_pdf: "Pobierz wyniki w PDF",
  },
  role: {
    admin: "Administrator",
    doctor: "Lekarz",
    patient: "Pacjent",
    user: "Użytkownik",
  },
  search: {
    examinations: "szukane badania",
    packages: "szukane pakiety",
  },
  select_time: {
    current_month: "Bieżący miesiąc",
    current_year: "Bieżący rok",
    last_30_days: "Ostatnie 30 dni",
    last_6_months: "Ostatnie 6 miesięcy",
    last_90_days: "Ostatnie 90 dni",
    previous_month: "Poprzedni miesiąc",
    selected_from: "Wybierz z kalendarza",
  },
  share: {
    patient_examinations: "Badania pacjenta",
    approvals: "Zgody",
    ask_for_access: "Poproś o dostęp do wyników badań",
    ask_was_send: "Prośba o dostęp do wyników badań została wysłana.",
    have_access: "Masz dostęp do wyników badań pacjenta.",
  },
  titles: {
    stats: "Statystyki",
    top_doctors: "Top lekarze",
    your_finances: "Twoje finanse",
    your_stats: "Twoje statystyki",
  },
  yes: "Tak",
  your_finances: {
    to_pay: "Do wypłaty",
  },
  your_referrals: {
    go_to_facility: "Udaj się do Punktu Pobrań, żeby wykonać badania.",
    just_paid: "Opłaciłeś już to zlecenie.",
    pay: "Opłać badania",
    see_results: "Zobacz wyniki badań",
    see_summary: "Zobacz podsumowanie",
  },
  your_settlements: {
    account_number: "Numer rachunku bankowego",
    account_number_title: "Numer rachunku bankowego",
    address: "Adres",
    address_title: "Adres",
    billing_data: "Dane do faktury",
    checkboxes: {
      agree_terms: "Oświadczam, iż przeczytałem i akceptuję",
      agree3:
        "Donec dolor mi, interdum vel arcu vel, gravida sollicitudin est. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed accumsan dui et sollicitudin porttitor",
      agree4:
        "Donec sed lacus leo. Fusce fermentum sem sed odio luctus, eu sollicitudin massa elementum. Maecenas pellentesque ligula libero, vel condimentum sem lobortis et",
      check_all: "Zaznacz wszystkie",
      marketing:
        "Wyrażam zgodę na przesyłanie informacji handlowych i marketingowych, za pośrednictwem środków komunikacji elektronicznej.",
      terms: "regulamin",
    },
    city: "Miejscowość",
    company_data_title: "Dane firmy",
    company_name: "Nazwa firmy / przychodni",
    edit_billing_data: "Edytuj dane do faktury",
    flat_number: "Numer lokalu",
    free_from_vat:
      "Oświadczam, iż przysługuje mi prawo do zwolnienia podmiotowego przewidzianego w art. 113 ust. 1 ustawy o VAT",
    free_from_vat_title: "Czy jesteś zwolniony z VAT?",
    house_number: "Numer budynku",
    invoice: {
      amount: "Kwota",
      date: "Data",
      download: "Pobierz fakture",
      number: "Numer faktury",
    },
    my_settlements: "Moje rozliczenia",
    nip: "NIP",
    postal_code: "Kod pocztowy",
    street: "Ulica",
    user_full_name: "Imię i nazwisko",
    verify_account: "Zweryfikuj konto",
    verify_data_text:
      "Podaj dane do rozliczeń, aby móc rozliczyć wynagrodzenie od wystawionych zleceń",
    verify_data_title: "Zweryfikuj swoje dane",
    your_invoices: "Twoje faktury",
  },
  your_stats: {
    canceled_referrals: "Anulowane zlecenia",
    commission: "Wynagrodzenie",
    completed_referrals: "Zrealizowane zlecenia",
    cost: "Koszt badań",
    issued_referrals: "Wystawione zlecenia",
    paid_referrals: "Opłacone zlecenia",
  },
  invoice: {
    yes: "Tak",
    no: "Nie",
    all: "Wszystkie",
    title: "Faktura",
    first_name: "Imię",
    last_name: "Nazwisko",
    company_name: "Nazwa firmy",
    nip: "NIP",
    street: "Ulica",
    house_number: "Numer domu",
    flat_number: "Numer lokalu",
    postal_code: "Kod pocztowy",
    city: "Miejscowość",
    additional_information: "Dodatkowe adnotacje",
  },
};
